
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(29|48|66)|609)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
